import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const Spinner = styled.img`
  border: 0;
  background: transparent;
`;

export const LoadingText = styled.p`
  color: white; 
  font-size: 1.1rem;
`
